export const witrinoStorage = {
    data() {
        return {
            witrinoCartObj: []
        };
    },
    methods: {
        addToCard(businessID, businessName, businessImage, businessPhone, product) {
            if (this.witrinoCartObj) {
                let x = this.witrinoCartObj.find((item, i) => {
                    if (item.businessID == businessID) {
                        let isDuplicate = this.witrinoCartObj[i].products.find((p, i2) => {
                            if (p.id == product.id) {
                                this.witrinoCartObj[i].products[i2] = product;
                                console.log("جایگزین شد")
                                return true;
                            }
                        });
                        if (!isDuplicate) {
                            this.witrinoCartObj[i].products.push(product);
                            console.log("is new product")
                        }
                        else {
                            console.log("is Duplicate product")
                        }
                        return true;
                    }
                });
                if (!x) {
                    let newBusiness = {
                        businessID: businessID,
                        businessName: businessName,
                        businessImage: businessImage,
                        businessPhone: businessPhone,
                        products: [
                            product
                        ],
                    };
                    this.witrinoCartObj.push(newBusiness);
                }
                //localStorage.setItem("witrinoCart", JSON.stringify(witrinoCartObj));
            }
            else {
                this.witrinoCartObj[0] = {
                    businessID: businessID,
                    businessName: businessName,
                    businessImage: businessImage,
                    businessPhone: businessPhone,
                    products: [
                        product
                    ],

                };
                //localStorage.setItem("witrinoCart", JSON.stringify(witrinoCartObj));
            }
        },
        getCartStorage() {
            return this.witrinoCartObj;
        },
        removeFromCart(businessID, productID) {
            this.witrinoCartObj = this.witrinoCartObj.filter((busines) => {
                if (busines.businessID != businessID) {
                    return busines
                }
                else {
                    let newProducts = busines.products.filter((product) => {
                        if (product.id != productID) {
                            return product
                        }
                    });
                    busines.products = newProducts;
                    if (busines.products.length > 0)
                        return busines
                }
            });
            //localStorage.setItem("witrinoCart", JSON.stringify(witrinoCartObj));
        }
    },
    mounted() {
        let witrinoCartStorage = localStorage.getItem("witrinoCart");
        //localStorage.setItem("witrinoCartStorage", null);
        //localStorage.removeItem("witrinoCartStorage");
        console.log(witrinoCartStorage);
        if (witrinoCartStorage) {
            this.witrinoCartObj = JSON.parse(witrinoCartStorage)?.cart ?? [];
        }
        else {
            this.witrinoCartObj = []
        }
    },
    watch: {
        witrinoCartObj: {
            deep: true,
            handler(NewVal, oldVal) {
                console.log("update witrinoCartObj >>>");
                console.log(this.witrinoCartObj);
                localStorage.setItem("witrinoCart", JSON.stringify({ cart: this.witrinoCartObj }))
            },
        },
    },

};